"use client";

// Import the service's type directly
import { migrateGenerate } from "../services/migration/migrateGenerate";

interface UseMigrationProcessResult {
  generateMigrate: (migrationId: string, xaccountid: string, appis: [] | any) => Promise<boolean>;
}

/**
 * Hook generate migrate
 */
export function useMigrateGenerate(): UseMigrationProcessResult {
  const generateMigrate = async (migrationId: string, xAccountId: string, appis: []) => {
    try {
      const response = await migrateGenerate(migrationId, xAccountId, appis);
      if (response.content && response.status === 200) {
        return response;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    generateMigrate,
  };
}
